import styled, { css } from 'styled-components';
import { SearchInputProps } from 'models/campaign-mkt';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: #475466;
  margin: 0 0 28px 0;
`;

export const PlaceholderStyled = styled.span`
  position: absolute;
  left: 20px;
  color: #98a2b3;
  font-family: 'Gotham' !important;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  pointer-events: none;
`;

export const InputWrapper = styled.div<SearchInputProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: ${({ width }) => width || '350'}px;
  background: #ffffff;
  border: 1px solid #e4e9f0;
  box-sizing: border-box;
  box-shadow: 0px 2px 1px rgba(0, 34, 102, 0.05);
  border-radius: 21px;
  height: ${({ height }) => height || '36'}px;

  ${({ filterOpened }) =>
    !filterOpened &&
    css`
      margin-left: 164px;
    `}

  ${({ variant }) =>
    variant === 'campaigns' &&
    css`
      width: 288px;
      height: 32px;
      padding: 0 20px;
      border-color: #e4e9f0;
      border-radius: 21px;
      box-shadow: none;

      && input {
        font-family: 'Gotham';
        font-size: 13px;
        font-weight: 300;
        line-height: 16px;
        color: #98a2b3;
      }
    `}

  input {
    border: none;
    flex: 1;
    min-width: 0;
    padding: 0 14px;
    border-radius: 18px;
    font-family: 'Gotham';
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;

    &::placeholder {
      font-family: 'Gotham';
      font-weight: normal;
      font-size: 13px;
      line-height: 14px;
      letter-spacing: 0.5px;
      color: rgb(117, 117, 117);
    }

    ${({ variant }) =>
      variant === 'campaigns' &&
      css`
        padding: 0;
        background: transparent;
        color: #98a2b3;
        font-size: 13px;
        font-weight: 500;
        line-height: 16px;

        &::placeholder {
          color: #98a2b3;
          font-family: 'Gotham';
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 0;
          opacity: 1;
        }
      `}
  }

  img {
    margin-right: 15px;
    width: 15px;
    height: auto;
    cursor: pointer;

    ${({ variant }) =>
      variant === 'campaigns' &&
      css`
        flex: 0 0 16px;
        width: 16px;
        height: 16px;
        margin-right: 0;
      `}
  }
`;
